import { Themes, themes } from '@masfront/common-b2c'

import { Brand } from '../model'

const themeForBrand = {
  [Brand.llamaya]: Themes.llamaya,
  [Brand.masmovil]: Themes.masmovil,
}

export function getThemeName(brand: Brand) {
  return themeForBrand[brand] as string
}

export function getTheme(brand: Brand) {
  return themes[getThemeName(brand) as keyof typeof Themes]
}

export function getBrandFromThemeName(themeNameIn: string) {
  const themeEntry = Object.entries(themeForBrand).find(
    ([_brandId, themeName]) => themeNameIn === themeName,
  )

  return themeEntry ? (themeEntry[0] as Brand) : Brand.masmovil
}
